import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { getFirmaStatus } from '../../../actions/noleggia/Firma'

class NltBrumbrumThanks extends Component {
  componentDidMount() {
    this.props.getFirmaStatus()
  }

  goToFirma() {
    const _this = this
    return () => {
      window.location.href = `${window.location.origin}/firma-nlt-brumbrum/landing/${_this.props.ordine.id_ordine}?token=${_this.props.customer.token}&reroute_to=/thank-you-firma-completata`
    }
  }

  isRecuperoOrdine() {
    return window.location.href.indexOf('utm_content=recupero-ordine') !== -1
  }

  render() {
    const { firma, product, isNltBrumbrumTyFirmato } = this.props
    return (
      <div className={'thank-you thank-you-final'}>
        {firma && firma.status === 'PRONTO_ALLA_FIRMA' ? (
          <div className={'thank-you__content'}>
            <div className="thank-you__top">
              {this.isRecuperoOrdine() ? (
                <h1 className={'thank-you--title'}>
                  Firma ora il documento del contratto
                </h1>
              ) : (
                <h1 className={'thank-you--title'}>
                  La richiesta di Noleggio a Lungo Termine per la tua{' '}
                  {product.marca} {product.modello} è partita!
                </h1>
              )}
              {this.isRecuperoOrdine() ? (
                <p className={'thank-you--intro'}>
                  Mancano pochissimi passi per concludere la tua richiesta di
                  noleggio a lungo termine.
                </p>
              ) : (
                <p className={'thank-you--intro'}>
                  Puoi scegliere se firmare subito il documento del contratto
                  oppure aspettare l'esito della richiesta di noleggio a lungo
                  termine. Entro 2 giorni ti contatteremo per aggiornarti sullo
                  stato di lavorazione della tua richiesta.
                </p>
              )}
            </div>
            <div className="thank-you__button" onClick={this.goToFirma()}>
              <a className="btn btn-primary" href={window.location.hash}>
                <span>
                  {this.isRecuperoOrdine() ? 'Firma adesso' : 'Firma'}
                </span>
              </a>
            </div>
          </div>
        ) : (
          <div className={'thank-you__content'}>
            <div className="thank-you__top">
              {isNltBrumbrumTyFirmato ? (
                <h1 className={'thank-you--title'}>
                  Complimenti!
                  <br />
                  Il documento è stato firmato.
                </h1>
              ) : (
                <h1 className={'thank-you--title'}>
                  La richiesta di Noleggio a Lungo Termine per la tua{' '}
                  {product.marca} {product.modello} è partita!
                </h1>
              )}
              {isNltBrumbrumTyFirmato ? (
                <p className={'thank-you--intro'}>
                  Ti contatteremo per aggiornarti sullo stato di lavorazione
                  della tua richiesta.
                  <br />
                  Grazie per aver scelto brumbrum!
                </p>
              ) : (
                <p className={'thank-you--intro'}>
                  Entro 2 giorni ti contatteremo per aggiornarti sullo stato di
                  lavorazione della tua richiesta.
                  <br />
                  Grazie per aver scelto brumbrum!
                </p>
              )}
            </div>
            <div className="thank-you__button">
              <a className="btn btn-primary" href="/">
                <span>Torna alla homepage</span>
              </a>
            </div>
          </div>
        )}
      </div>
    )
  }
}

NltBrumbrumThanks.defaultProps = {
  isNltBrumbrumTyFirmato: false,
}

NltBrumbrumThanks.propTypes = {
  product: PropTypes.object,
  customer: PropTypes.object,
  ordine: PropTypes.object,
  firma: PropTypes.object,
  getFirmaStatus: PropTypes.func,
  isNltBrumbrumTyFirmato: PropTypes.bool,
}

const mapStateToProps = state => ({
  firma: state.nlt.firma,
  ordine: state.ordine,
  customer: state.customer,
  product: state.product,
})

const mapDispatchToProps = dispatch => ({
  getFirmaStatus: () => dispatch(getFirmaStatus),
})

export default connect(mapStateToProps, mapDispatchToProps)(NltBrumbrumThanks)
